export default{
    name: "ImageTextBox",
    data(){
        return{

        }
    },
    props: {
        imagePath: {
            type: String
        },
        title: {
            type: String
        },
        description: {
            type: String
        },
        titleBefore: {
            type: Boolean,
            default: true
        }
    }
}
